import { useState } from "react";
import { api } from "../../../../api";
import { Button } from "../../../../externalComponents/tailwind/button";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "../../../../externalComponents/tailwind/dialog";

export default function DeleteAllUnusedCouponsDialog({
  open,
  onClose,
  customerId,
  categoryFilter,
}) {
  console.log("categoryFilter", categoryFilter);
  const [isDeleting, setIsDeleting] = useState(false);
  const handleDelete = () => {
    try {
      setIsDeleting(true);
      api.settings.deleteAllUnusedCustomCouponCodes({
        customerId,
        categoryFilter,
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete all unused coupons</DialogTitle>
      <DialogBody>
        {isDeleting ? (
          <>
            <p>This action might take a moment.</p>
            <p>You can close this window while it's processing.</p>
          </>
        ) : (
          <>
            <p>Are you sure you want to delete all the unused coupon codes</p>
            <p>This action cannot be undone.</p>
          </>
        )}
      </DialogBody>
      <DialogActions>
        {isDeleting ? (
          <Button color="secondaryButton" onClick={onClose}>
            Close
          </Button>
        ) : (
          <>
            <Button color="secondaryButton" onClick={onClose}>
              Cancel
            </Button>
            <Button color="red" onClick={handleDelete}>
              Delete
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}
